module.exports = __webpack_public_path__ + "img/home_icon_yuanlin_sel.2ef83c06.png";